module.exports = __webpack_public_path__ + "img/3.cf8f42bd.jpg";